import { Token } from '@akropolis-web/primitives';

import { asNetworkSlug } from 'domain/types';

import { schemas } from '../apostro-rest/types';

export function convertToken(token: schemas['Token']): Token {
  return new Token(token.address, token.symbol, token.decimals, asNetworkSlug(token.network));
}
